import React from 'react';
import { isTruthyAndNotEmpty } from '@stimcar/libs-kernel';
import * as m from '../paraglide/messages.js';
import type { SessionSummaryView } from './api.js';
import { CloseIcon } from './icons.js';

export type SessionHistoryPanelProps = {
  readonly items: readonly SessionSummaryView[];
  readonly currentSessionId: string | undefined;
  readonly onSelect: (urlPath: string) => void;
  readonly onClose: () => void;
};

export function sessionHistoryTitle(item: SessionSummaryView): string {
  if (isTruthyAndNotEmpty(item.title.trim())) {
    return item.title;
  }
  return m.untitledConversation();
}

export function sessionHistoryCreator(item: SessionSummaryView): string {
  if (isTruthyAndNotEmpty(item.createdByEmail.trim())) {
    return item.createdByEmail;
  }
  return m.unknownCreator();
}

export function SessionHistoryPanel(props: SessionHistoryPanelProps): React.ReactElement {
  return (
    <div className="session-history" role="region" aria-label={m.conversationHistory()}>
      <div className="session-history-header">
        <h2>{m.conversationHistory()}</h2>
        <button
          type="button"
          className="icon-button"
          aria-label={m.closeConversationHistory()}
          title={m.closeConversationHistory()}
          onClick={props.onClose}
        >
          <CloseIcon />
        </button>
      </div>
      {props.items.length === 0 ? (
        <p className="session-history-empty">{m.conversationHistoryEmpty()}</p>
      ) : (
        <ul className="session-history-list">
          {props.items.map((item) => {
            const selected = item.id === props.currentSessionId;
            return (
              <li key={item.id}>
                <button
                  type="button"
                  className={selected ? 'session-history-item is-selected' : 'session-history-item'}
                  onClick={() => {
                    props.onSelect(item.urlPath);
                  }}
                >
                  <span className="session-history-title">{sessionHistoryTitle(item)}</span>
                  <span className="session-history-meta">
                    <span className="session-history-target">{item.targetLabel}</span>
                    <span className="session-history-creator">{sessionHistoryCreator(item)}</span>
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
